import { useEffect, useState } from "react";
import styles from "./LinkPreview.module.css";

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

export const extractUrls = (text) => {
  return text?.match(URL_REGEX) || [];
};

const LinkPreview = ({ url, isOwn }) => {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    // Use a simple approach — show the domain and URL
    try {
      const u = new URL(url);
      setMeta({
        domain: u.hostname.replace("www.", ""),
        url,
        title: u.hostname.replace("www.", ""),
      });
    } catch (_) {}
  }, [url]);

  if (!meta) return null;

  return (
    <a
      href={meta.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`${styles.preview} ${isOwn ? styles.previewOwn : styles.previewOther}`}
    >
      <div className={styles.previewDomain}>🔗 {meta.domain}</div>
      <div className={styles.previewUrl}>{meta.url.length > 50 ? meta.url.slice(0, 50) + "..." : meta.url}</div>
    </a>
  );
};

export default LinkPreview;
